import React from 'react'
import { Badge } from 'reactstrap'

// addAssignmentToUser, removeAssignmentFromUser, add, assignmentId, userId

export default function AssignBadge ({addAssignmentToUser, removeAssignmentFromUser, add, assignmentId, userId}) {
  
  let badge
  add
  ? badge = (
      <Badge
        color='success'
        onClick={assignmentId ? () => addAssignmentToUser(assignmentId, userId) : null}
        className='m2clickable'
      >
        + Assign
      </Badge>
    )
  : badge = (
      <Badge
        color='danger'
        onClick={assignmentId ? () => removeAssignmentFromUser(assignmentId, userId) : null}
        className='m2clickable'
      >
        - Assign
      </Badge>
    )
  
  return (
    <div>{badge}</div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignBadge.js